import React, {useState} from 'react';
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {ModalIds, useModal} from "../../contexts/ModalContext";
import ClearIcon from "@mui/icons-material/Clear";
import DialogTitle from "@mui/material/DialogTitle";
import {useMediaQuery} from "@mui/material";
import {DialogStyled} from "./modalComponent";
import {HrLine} from "../styledComponent/styledComponents";
import Typography from "@mui/material/Typography";
import PinInput from "react-pin-input";
import Stack from "@mui/material/Stack";
import Counter from "../counter/counter";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {useUser} from "../../features/user/userSlice"
import {useSendAccreditationOtpCodeMutation} from "../../features/apiSlice/accreditation-otp"
import {toast} from "react-toastify";


const RequestInquiryModal = () => {
    const [pinInputError, setPinInputError] = useState(false)
    const {handleClose, modalId, modalOption, setModalOption} = useModal()
    const [sendOtp, {isLoading, error}] = useSendAccreditationOtpCodeMutation()
    const {data: userData} = useSelector(useUser)

    const matches = useMediaQuery('(min-width:200px) and (max-width:600px)');
    const navigate = useNavigate()
    return (
        <DialogStyled open={modalId === ModalIds.REQUEST_INQUIRY} onClose={handleClose}
                      minWidth={!matches ? "600px" : "330px"} minHeight={300}>
            <DialogTitle sx={{alignSelf: "end", height: 54}}>
                <ClearIcon onClick={handleClose} color={"fourth"} sx={{marginLeft: -1}}/>
            </DialogTitle>
            <HrLine/>
            <DialogContent>
                <Typography fontSize={{xs: 12, sm: 14}} textAlign={"right"} color={'#7A7A7A'} lineHeight={2}>
                    برای ثبت درخواست استعلام، کد تایید ارسال شده به شماره {userData?.user?.cell} را وارد کنید.
                </Typography>
                <Stack>
                    <PinInput
                        length={5}
                        focus={true}
                        initialValue=""
                        onChange={(value, index) => {
                            setPinInputError(false)
                        }}
                        type="numeric"
                        inputMode="number"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: matches ? "4px" : "12px",
                            paddingTop: "30px",
                            direction: 'ltr'
                        }}
                        inputStyle={{
                            width: matches ? '46px' : '56px',
                            height: matches ? '46px' : '56px',
                            borderRadius: '12px',
                            fontSize: '18px',
                            border: '1px solid #D9E2E7',
                            backgroundColor: pinInputError ? "rgb(253,237,237)" : "#fff",
                            textAlign: 'center'
                        }}
                        disabled={(modalOption < 0)}
                        inputFocusStyle={{border: '1px solid #FD6A16'}}
                        onComplete={(value, index) => {
                            sendOtp({otp: value})
                                .unwrap()
                                .then(response => {
                                    console.log('response',response)
                                    if (response.status === "success") {
                                        handleClose()
                                        navigate("/credit-score-inquiry");
                                        toast.success(response.message)
                                    } else {
                                        toast.error(response.message)
                                        setPinInputError(true)
                                    }
                                }).catch(err => toast.error(err.message))
                        }}
                        autoSelect={true}
                        regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Counter/>
            </DialogActions>
        </DialogStyled>
    );
};

export default RequestInquiryModal;